import { memberQuotes } from '@/mocks/communityData';
import SectionHeading from './SectionHeading';

const avatarClass: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function Community() {
  return (
    <section id="community" className="bg-accent-900">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="互动口碑"
          title="真实的料友，都在认真分享与回应"
          desc="从新手到老手，大家在这里互相学习、彼此回应。听听几位常驻料友是怎么说的。"
          align="center"
        />

        <div className="mt-9 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {memberQuotes.map((m) => (
            <figure
              key={m.name}
              className="flex flex-col rounded-xl bg-background-50 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-3xl text-accent-600"></i>
              <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-800">
                {m.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${avatarClass[m.avatarColor]}`}
                >
                  {m.avatarText}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{m.name}</p>
                  <p className="text-xs text-foreground-500">{m.role}</p>
                </div>
                <i className="ri-star-fill ml-auto text-secondary-500"></i>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}